export default {
  meta: {
    title: '场地筛选（慢闪店）'
  }
};
